import React from 'react';
import { Layout, BackTop, Affix, Button, Tooltip } from 'antd';

// Local imports
import Header from '../../ux/Header';
import Sidebar from '../../ux/Sidebar';
import MobileNavigationModal from '../../shared/components/navigation/MobileNavigationModal';
import SystemAlertBarContainer from '../../../core/components/system-alerts/SystemAlertBarContainer';
import { CloseOutlined } from '@ant-design/icons';

const { Content } = Layout;
const style = {
  layout: {
    background: '#f0f2f5',
    minHeight: '100vh',
    height: '100%',
  },

  widget: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'inline-block',
    zIndex: 11, // Must be higher than Header (z-index: 10) to show preview mode banner
  },

  showStyle: {
    display: 'none',
  },

  footer: { textAlign: 'center' },
};

class MainLayout extends React.PureComponent {
  state = {
    collapsed: false,
    direction: 'right',
    mobileNavigationOpen: false,
  };

  toggleSideBar = (collapsed) => {
    this.setState({
      collapsed,
    });
  };

  toggleMobileNavigation = () => {
    this.setState((prevState) => ({
      mobileNavigationOpen: !prevState.mobileNavigationOpen,
    }));
  };

  render() {
    return (
      <Layout>
        {this.props.currentUser.isPreviewOrg ? (
          <div style={{ ...style.widget }}>
            <Affix offsetTop={10}>
              <div style={{ display: 'inline-flex' }}>
                <Button style={{ marginLeft: -10 }} type="primary" shape="round">
                  Preview Mode ({this.props.currentUser.role.org.name})
                </Button>
                <Tooltip title={'Revert back to current Org'}>
                  <Button
                    style={{ marginLeft: 10 }}
                    type="danger"
                    shape="circle"
                    icon={<CloseOutlined />}
                    onClick={() => {
                      localStorage.removeItem('userData');
                      window.location.href = `/orgs/${this.props.currentUser.role.org.id}`;
                    }}
                  ></Button>
                </Tooltip>
              </div>
            </Affix>
          </div>
        ) : null}

        <Sidebar
          features={this.props.currentUser.features}
          logo={this.props.currentUser.role.org.logo}
          state={this.state}
          toggleSideBar={this.toggleSideBar}
          horizontalNavigation={this.props.horizontalNavigation}
          themeData={this.props.themeData}
          currentUser={this.props.currentUser}
          chatWootId={this.props.chatWootId}
          chatWootLoading={this.props.chatWootLoading}
        />

        <Layout style={style.layout}>
          <Header
            state={this.state}
            toggleSideBar={() => {
              this.toggleSideBar(!this.state.collapsed);
            }}
            showMobileNavigation={this.toggleMobileNavigation}
            accounts={this.props}
          />
          <Content>{this.props.children}</Content>
        </Layout>
        <BackTop id="backtop" />
        <MobileNavigationModal
          visible={this.state.mobileNavigationOpen}
          onClose={this.toggleMobileNavigation}
          currentUser={this.props.currentUser}
          themeData={this.props.themeData}
        />
        <SystemAlertBarContainer currentUser={this.props.currentUser} />
      </Layout>
    );
  }
}

export default MainLayout;
